<form action="{{url}}"
 class="paymentWidgets" data-brands="VISA MASTER AMEX"></form>
